import { translations, productTranslations } from "./translations.js";
import { messages, messageAliases } from "./messages.js";

export const normalizeLanguage = (value) => value === "en" ? "en" : "ar";
export const languageLocale = (language) => normalizeLanguage(language) === "ar" ? "ar-OM" : "en-GB";
const normalizeText = (value) => value.trim().replace(/\s+/g, " ");
const uiMessages = { ar: new Map(), en: new Map() };
const products = { ar: new Map(), en: new Map() };

function addPair(target, ar, en) {
  if (!ar || !en || ar === en) return;
  for (const source of [ar, en]) {
    target.ar.set(normalizeText(source), ar);
    target.en.set(normalizeText(source), en);
  }
}
for (const key of Object.keys(translations.en)) addPair(uiMessages, translations.ar[key], translations.en[key]);
for (const [en, ar] of Object.entries(messages)) addPair(uiMessages, ar, en);
for (const [ar, en] of Object.entries(productTranslations)) addPair(products, ar, en);

export function interpolate(text, values = {}) {
  return text.replace(/\{(\w+)\}/g, (match, key) => Object.hasOwn(values, key) ? String(values[key]) : match);
}

export function translateMessage(value, language, values) {
  if (typeof value !== "string" || !value) return value;
  const source = normalizeText(value);
  const normalized = messageAliases[source] || source;
  const translated = uiMessages[normalizeLanguage(language)].get(normalized);
  if (!translated) return interpolate(value, values);
  const leading = value.match(/^\s*/)[0];
  const trailing = value.match(/\s*$/)[0];
  return interpolate(`${leading}${translated}${trailing}`, values);
}

export function localizeCatalogText(value, language, catalog = {}, record, field = "name") {
  if (typeof value !== "string" || !value) return value;
  const lang = normalizeLanguage(language);
  const normalized = normalizeText(value);
  const explicit = record?.[`${field}_${lang}`];
  const remote = catalog[lang]?.[value] || catalog[lang]?.[normalized];
  // A copied source is not a translation; prefer the curated fallback in that case.
  const translated = [explicit, remote].find(text => typeof text === "string" && text.trim() && normalizeText(text) !== normalized);
  return translated || products[lang].get(normalized) || translateMessage(value, lang);
}
